const jsonFormatter = {
    format(rawLog) {
        return JSON.stringify(rawLog);
    },
};

export { jsonFormatter };
//# sourceMappingURL=JsonFormatter.js.map
